import { max, min } from 'date-fns';
import { reduce } from 'ramda';

type DateBoundary = Date | null;
interface DateBoundaries {
  earliest: DateBoundary;
  latest: DateBoundary;
}

const compareDates = (
  compareOperator: <DateType extends Date>(dates: (DateType | number | string)[]) => DateType | Date,
  ...values: DateBoundary[]
) => {
  return compareOperator([...values.filter((value) => value !== null)]);
};

export const getDateBoundaries = (
  lineItems: { earlyDeliveryAt: DateBoundary; lateDeliveryAt: DateBoundary }[],
): DateBoundaries =>
  reduce(
    (acc, item) => {
      const { earlyDeliveryAt, lateDeliveryAt } = item;

      // Compare current item dates with accumulator's earliest and latest
      return {
        earliest: compareDates(min, acc.earliest, earlyDeliveryAt, lateDeliveryAt),
        latest: compareDates(max, acc.latest, earlyDeliveryAt, lateDeliveryAt),
      };
    },
    { earliest: null, latest: null } as DateBoundaries,
    lineItems,
  );
